<template>
  <div class="third-formOne contacts-man">
    <div class="formOne-btn">
      <div class="btn-left">
        <span class="left-back-icon" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          <span class="left-back-title">返回</span>
        </span>
        <span class="left-back-shu">
          <span class="left-back-shu-content"></span>
        </span>
        <span class="left-back-content">详情</span>
      </div>
      <div class="btn-right"></div>
    </div>

    <el-form
      style="margin-top: 57px;"
      :model="info"
      ref="otherForm"
      label-width="86px"
      :show-message="false"
    >
      <div class="formOne-forms">
        <div class="forms-one">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">用户信息</span>
            </div>
          </div>
          <div class="one-list">
            <div class="list-one-line">
              <el-form-item label="账号：">
                <span style="font-size: 12px; color: #828D9A;">{{ info.account }}</span>
              </el-form-item>
              <el-form-item label="身份：">
                <span style="font-size: 12px; color: #828D9A;">{{ getIdentity(info.identity) }}</span>
              </el-form-item>
            </div>
            <div class="list-one-line">
              <el-form-item label="姓名：">
                <span style="font-size: 12px; color: #828D9A;">{{ info.realName }}</span>
              </el-form-item>
              <el-form-item label="角色：">
                <span style="font-size: 12px; color: #828D9A;">{{ getRole(info.role) }}</span>
              </el-form-item>
            </div>
            <div class="list-one-line">
              <el-form-item label="性别：">
                <span style="font-size: 12px; color: #828D9A;">{{ info.sex === 1 ? '男' : '女' }}</span>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="forms-one" v-if="info.emergencies.length > 0">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">紧急联系人信息</span>
            </div>
          </div>
          <div class="one-list"
            v-for="(item, index) in info.emergencies"
            :key="index">
            <div class="list-one-line">
              <el-form-item label="姓名：">
                <span style="font-size: 12px; color: #828D9A;">{{ item.name }}</span>
              </el-form-item>
            </div>
            <div class="list-one-line">
              <el-form-item label="关系：">
                <span style="font-size: 12px; color: #828D9A;">{{ item.relationshipName }}</span>
              </el-form-item>
            </div>
            <div class="list-one-line">
              <el-form-item label="联系方式：">
                <span style="font-size: 12px; color: #828D9A;">{{ item.tel }}</span>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>

  </div>
</template>

<script>
import { removeStore, getStore } from "@/utils/store";

export default {
  data() {
    return {
      info: {
        emergencies: []
      },
    }
  },
  computed: {
    roleList() {
      const { roleList } = this.$store.state.deviceMan;
      if (roleList) {
        return roleList
      }
      return []
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const rowData = getStore({
        name: "rowData",
        type: "session"
      });
      this.$store.dispatch('getEmergencyDetails', {
        userId: rowData.userId,
      }).then((res) => {
        if (res.data.status === 1000) {
          const { result } = res.data;
          this.info = result;
        }
      })
    },
    getRole(roles) {
      if (!roles) return;
      let roleArr = roles.split(',');
      roleArr = roleArr.filter(item => item)
      let roleNameArr = []
      if (roleArr.length > 0) {
        roleArr.forEach(element => {
          const [role] = this.roleList.filter(item => element == item.id)
          if (role) roleNameArr.push(role.roleName);
        })
      }
      const names = roleNameArr.join('，')
      return names
    },
    goBack() {
      this.$emit('changeComponent', 'homePage');
    },
    getIdentity(val) {
      let value = '';
      if (val === 'STUDENT') {
        value = '学生';
      } else if (val === 'TEACHER') {
        value = '老师';
      } else if (val === 'OTHER') {
        value = '其他';
      }
      return value
    }
  }
}
</script>

<style lang="scss">
.contacts-man {
  .list-one-line {
    width: 33%;
  }
}
</style>
